/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountBatchRequest extends models.RecordIdentityBatchRequest {
    getFixupPrototypeFunction() { return ServiceAccountBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountBatchRequest>): ServiceAccountBatchRequest {
        let obj = Object.assign(new ServiceAccountBatchRequest(), model);
        ServiceAccountBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountBatchRequest>): ServiceAccountBatchRequest {
        if (!model) return null;
        return ServiceAccountBatchRequest.newInstance(<ServiceAccountBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountBatchRequest) {
        if (!obj) return;

        models.ServiceAccountBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountBatchRequest): boolean {
        if (models.RecordIdentityBatchRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Also include billing accounts as parents.
     */
    include_billing_as_parent: boolean = false;

    /**
     * List of fields to include in the response. Must be a subset of ServiceAccountDetails keys.
     */
    include_fields: Array<models.ServiceAccountDetailsField>;

    /**
     * List of fields to include in the response. Must be a subset of ServiceAccountSync keys.
     */
    include_sync_status: Array<models.ServiceAccountSyncField>;

    additional_fields: Array<models.ServiceAccountDetailsAdditionalField>;

}
